import { CloseIssuesFormData } from "./types";

export function getCloseIssuesFormDataInitialValues(): CloseIssuesFormData {
  return {
    message: '',
  };
}
